import { useEffect } from 'react'
import { MAX_ODOMETER } from '@/Ship/Helpers/odometer'
import { useFormModal as useFormModalJs } from '@/Ship/Hooks/useFormModal'

/** Хук на JS: його типи виведені з дефолтів (null), тож працюємо з ним як з any */
// eslint-disable-next-line no-unused-vars -- false positive: ESLint core rule flags param names in function-type signatures
const useFormModal = useFormModalJs as (options: Record<string, any>) => { Modal: any; localStorage: any }

/** Перезавантажити картку й список за нею після дії */
const reload = (crudContext: any) => {
    crudContext?.actions?.reloadData?.()
    ;(crudContext?.listCrudContext?.listContext ?? crudContext?.listContext)?.actions?.load?.(true)
}

const uuidOf = (crudContext: any): string => String(crudContext?.formContext?.values?.uuid ?? '')

/**
 * Модалки дій картки зміни для диспетчера: «Розпочати зміну» (одометр + підтвердження)
 * і «Завершити зміну» (кінцевий одометр + зауваження). Перевірки — на бекенді (422).
 */
export const ShiftViewActions = ({ crudContext }: any) => {
    const { Modal: StartModal, localStorage: startModal } = useFormModal({
        fields: {
            startOdometer: {
                label: 'Початковий одометр, км',
                type: 'number',
                isRequired: true,
                inputProps: { min: 0, max: MAX_ODOMETER, precision: 0 },
            },
            documentsConfirmed: {
                label: 'Підтверджено наявність документів',
                type: 'checkbox',
                isRequired: true,
            },
            safetyBriefingConfirmed: {
                label: 'Підтверджено проходження інструктажу з безпеки руху',
                type: 'checkbox',
                isRequired: true,
            },
        },
        modalProps: { title: 'Розпочати зміну', okText: 'Розпочати' },
        restUri: '/services/shifts/__uuid__/start',
        restUriReplaceParams: (uri: string) => uri.replace('__uuid__', uuidOf(crudContext)),
        requestSuccessMessage: 'Зміну розпочато',
        onAfterSuccessRequest: () => reload(crudContext),
    })

    const { Modal: CompleteModal, localStorage: completeModal } = useFormModal({
        fields: {
            endOdometer: {
                label: 'Кінцевий одометр, км',
                type: 'number',
                isRequired: true,
                inputProps: { min: 0, max: MAX_ODOMETER, precision: 0 },
            },
            technicalRemarks: {
                label: 'Зауваження до технічного стану ТЗ',
                type: 'textarea',
            },
        },
        modalProps: { title: 'Завершити зміну', okText: 'Завершити' },
        restUri: '/services/shifts/__uuid__/complete',
        restUriReplaceParams: (uri: string) => uri.replace('__uuid__', uuidOf(crudContext)),
        requestSuccessMessage: 'Зміну завершено',
        onAfterSuccessRequest: () => reload(crudContext),
    })

    useEffect(() => {
        const em = crudContext?.eventManager
        if (!em) return undefined

        em.on('shiftAction:openStart', 'shiftStartModalHandler', () => startModal.setIsModalOpen(true))
        em.on('shiftAction:openComplete', 'shiftCompleteModalHandler', () => completeModal.setIsModalOpen(true))

        return () => {
            em.off('shiftAction:openStart', 'shiftStartModalHandler')
            em.off('shiftAction:openComplete', 'shiftCompleteModalHandler')
        }
    }, [crudContext, startModal, completeModal])

    return (
        <>
            <StartModal />
            <CompleteModal />
        </>
    )
}
